export const formatPrice = (number, eur,withOutCurrency) => {
  if (!withOutCurrency){
    return number.toLocaleString('hu-HU', {
      style: 'currency',
      currency: eur ? 'EUR' : 'HUF',
      minimumFractionDigits: 0,
      maximumFractionDigits: eur ? 2 : 0,
      useGrouping: true,
      groupingSeparator: ' ',
    });
  }

  return number.toLocaleString('hu-HU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: eur ? 2 : 0,
    useGrouping: true,
    groupingSeparator: ' ',
  });
};
